export default "__VITE_ASSET__BcGEn7kC__"